import './definition.css'
import imgUrl from '../../../../assets/img/general/definition_img.png'

export default function Definition() {
  return (
    <section className='definition-section'>
      <div className='definition-section__header'>
        <h2 className='definition-section__title'>Nuestra Trayectoria</h2>
        <div className='definition-section__divider'></div>
      </div>

      <div className='definition-section__content'>
        <div className='definition-section__image-box'>
          <div className='definition-section__image-wrapper'>
            <img src={imgUrl} alt='Encuentro Tienda Roja' className='definition-section__image' />
            <div className='definition-section__image-overlay'></div>
          </div>
        </div>

        <div className='definition-section__text-box'>
          <div className='definition-section__text-content'>
            <p className='definition-section__paragraph'>
              En el año 2021 nos constituimos como <strong>Asociación</strong> y tras el paréntesis del confinamiento, en el año 2022, convocamos la primera <strong>Tienda Roja</strong> como un espacio distendido y fértil para reconocernos como educadoras, terapeutas, divulgadoras, investigadoras y emprendedoras vinculadas a la nueva Cultura Menstrual.
            </p>
            
            <p className='definition-section__paragraph'>
              Más adelante apareció la figura de <strong>"Amiga Colaboradora"</strong> de la Asociación con las que mantenemos encuentros online <strong>"Cíclica-mente reunidas"</strong> y realizamos diferentes tipos de colaboraciones y de reuniones de trabajo tanto en el ámbito de la investigación, la innovación y la educación.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}